import { getSwedbankErrorMessage } from '../utils';

import swedbankRequest from './index';

const swedbankPayment = async (
  cardPayment,
  { currencyCode },
  { updateMessage },
  numberOfPayments,
  index,
  clientCode,
) => {
  updateMessage(
    `Performing payment for ${cardPayment.amount}...
    Transaction ${index + 1} / ${numberOfPayments}`,
  );
  const data = {
    requestID: cardPayment.uuid,
    transactionType: 'SALE',
    amount: cardPayment.amount,
    invoiceNr: `${cardPayment.added}`,
    currency: currencyCode,
    softwareName: 'Erply Brazil POS',
    softwareVersion: '3.32.3',
    clientCode,
  };

  try {
    const payment = await swedbankRequest.post('payment', data);

    return payment;
  } catch (error) {
    const errorMessage = await getSwedbankErrorMessage(
      error,
      'There was an error while performing the payment. Please try again',
    );

    updateMessage(errorMessage);
  }
  return true;
};

export default swedbankPayment;
